import { CssProperties, ICssProperty } from "src/models/css-property";
import { IMembersAreaWidgetContainerStyle } from "src/typings/website-members/members-area-widget-container-style";
import { StringUtil } from "src/utils/string-util";

export class MembersAreaWidgetContainerStyleRenderer {

    public getStyles(data: IMembersAreaWidgetContainerStyle): ICssProperty[] {
        const styles = new CssProperties();

        styles.tryAdd("--container-background-color", data.backgroundColor);
        styles.tryAdd("--container-padding", `${data.padding}px`);

        if (data?.borderRadius) {
            styles.tryAdd("--container-border-top-left-radius", `${data.borderRadius.topLeftPx}px`);
            styles.tryAdd("--container-border-top-right-radius", `${data.borderRadius.topRightPx}px`);
            styles.tryAdd("--container-border-bottom-left-radius", `${data.borderRadius.bottomLeftPx}px`);
            styles.tryAdd("--container-border-bottom-right-radius", `${data.borderRadius.bottomRightPx}px`);
        }

        styles.tryAdd("--container-font-family", data.font.family);
        styles.tryAdd("--container-font-size", String(StringUtil.getNumberFromStr(data.font.size)));
        styles.tryAdd("--container-font-color", data.font.color);

        styles.tryAdd("--container-link-color-default", data.linkColor.colorDefault);
        styles.tryAdd("--container-link-color-hovered", data.linkColor.colorHovered);
        styles.tryAdd("--container-link-color-clicked", data.linkColor.colorDefault); // because the colorClicked is not configured separately in the settings

        return styles.data;
    }

}
